'use strict';

// CSS ANIMATION CALLBACK
// ----------------------------------------------------------------------------
function whichAnimationEvent() {
    var t,
    el = document.createElement('fakeelement');

    var animations = {
        'animation': 'animationend',
        'OAnimation': 'oAnimationEnd',
        'MozAnimation': 'animationend',
        'WebkitAnimation': 'webkitAnimationEnd'
    };

    for (t in animations){
        if (el.style[t] !== undefined){
            return animations[t];
        }
    }
}


// TOAST
// ----------------------------------------------------------------------------

var showToast = function (options) {
    var settings = $.extend({
        style: 'ok',
        icon: 'icon-ok',
        iconSvg: 'ok',
        paragraph: 'Guardando',
        delayTime: 1500
    }, options);

    var $toast;
    var animationEvent = whichAnimationEvent();

    var createToast = function() {
        $toast = $('<div>', {
            class: 'anim-move-up-fade-in mt-toast mt-toast--fixed mt-toast--' + settings.style
        });

        var $iconWrap = $('<span>', {
            class: settings.icon
        });

        var $paragraphWrap = $('<p>', {
            class: 'mt-toast__text',
            text: settings.paragraph
        });

        $iconWrap.appendTo($toast);
        $paragraphWrap.appendTo($toast);
        $toast.appendTo($('body'));
    };
    var removeToast = function() {
        $toast.removeClass('anim-move-up-fade-in');
        $toast.addClass('anim-move-up-fade-out');

        $(this).one(animationEvent, function(event) {
            $toast.remove();
        });
    };
    var displayToast = function() {
        createToast();
        window.setTimeout( function() {
            removeToast();
        }, settings.delayTime);
    };
    return displayToast();
};
